module.exports = __webpack_public_path__ + "static/media/chevron-up.d3ef5917.svg";